import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt, faCircle, faCode, faRotate, faSquare} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {IconProp, SizeProp} from "@fortawesome/fontawesome-svg-core";
import {IconBoltGrad} from "../../components/icons/faBoltGrad";

export const BoltIcon = (
    props: {
        size?: number
        color?: string,
        secondary: IconProp
    }
) => {
    const baseSize = 24
    const baseOffset = ((props.size ?? baseSize)) / 6

    return (
        <span className={`fa-layers fa-fw`} style={{
            width: props.size ?? baseSize,
            height: props.size ?? baseSize
        }}>
                        <FontAwesomeIcon
                            icon={props.secondary}
                            color={props.color}
                            style={{
                                width: props.size ?? baseSize,
                                height: props.size ?? baseSize,
                            }}
                        />
            <IconBoltGrad
                className={"bolt-sub"}
                style={{
                    width: (props.size ?? baseSize) / 2,
                    height: (props.size ?? baseSize) / 2,
                    right: -baseOffset,
                    bottom: -baseOffset,
                    position: "absolute",
                    top: "auto",
                    left: "auto",
                    // padding: (props.size ?? baseSize) / (baseSize / 2)
                }}
            />
        </span>
    )
}